import { Model as BaseModel } from 'vue-api-query'

export default class Model extends BaseModel {
    // define a base url for a REST API
    baseURL() {
        return process.env.VUE_APP_API_ROUTE
    }

    /**
     * @description
     * clean the current model
     */
    clean(props = []) {
        // clone the current model
        var clone = this.clone()

        // delete every prop no content in props param
        Object.keys(clone).forEach(key => {
            if (!props.some(prop => prop === key)) {
                delete clone[key]
            }
        })

        // return clean clone
        return clone
    }

    /**
     * @description
     * clone the current model
     */
    clone() {
        return Object.assign(Object.create(Object.getPrototypeOf(this)), this)
    }

    /**
     * @description
     * return a collection from current model
     *
     * @param {String} name - collection name
     */
    collection(name) {
        //
        this[name].clean = function() {
            var that = this;
            while(that.length){
                that.shift();
            }
            return that;
        }
        //
        return this[name]
    }

    // implement a default request method
    request(config) {
        return this.$http.request(config)
    }

    /*static append(...params) {
        this.appends = [...params]; return this;
    }*/
}
